export const theme = {
  borderRadius: 4,
  borderWidth: 1,
}
